// https://www.gatsbyjs.com/docs/reference/built-in-components/gatsby-head/
import React, { useEffect, useState } from 'react'
import { useLocation } from '@reach/router'
import { Header } from './header'
import { GlobalStyle } from '../theme'
import { PrivacyPolicy } from './privacy-policy'
import { Footer } from './footer'
import './global.css'
import { useCheckLogin } from '../hooks/use-check-login'
import { FloatBar } from './float-bar'
import { Helmet } from 'react-helmet'
import { ContactBar } from './contact-bar'
import { LocaleClass } from '../utils'
import { TopBanner } from './top-banner'
import { Main } from './atoms'
import { LOCALE } from '@foxrenderfarm/internals'

interface Props {
  children: React.ReactNode
  isMultilingual?: boolean
  isSupportPage?: boolean
  hideHeader?: boolean
  hideTopBanner?: boolean
  displayLanguages?: LOCALE[]
}

export const Layout = ({
  children,
  isMultilingual = false,
  isSupportPage = false,
  hideHeader = false,
  hideTopBanner = false,
  displayLanguages = undefined,
}: Props) => {
  const location = useLocation()
  const locale = LocaleClass.getCurrentLocaleName(location.pathname)
  const [origin, setOrigin] = useState('') // origin 在 useLocation 中为 undefined
  const [showTopBanner, setShowTopBanner] = useState(true)

  useEffect(() => {
    setShowTopBanner(!hideTopBanner)
    setOrigin(window.location.origin)
    window.addEventListener('mousemove', loadSalesmartly)
    return () => {
      window.removeEventListener('mousemove', loadSalesmartly)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useCheckLogin()

  const handleShowTopBanner = (v: boolean) => setShowTopBanner(v)

  const loadSalesmartly = async () => {
    window.removeEventListener('mousemove', loadSalesmartly)
    new Promise((resolveScript, rejectScript) => {
      const s = document.createElement('script')
      const s0 = document.getElementsByTagName('script')[0]
      s.defer = true
      s.src = 'https://assets.salesmartly.com/js/project_36837_38457_1704781084.js'
      s.onload = resolveScript
      s.onerror = rejectScript
      s0.parentNode?.insertBefore(s, s0)
    }).catch(console.error)
  }

  return (
    <>
      <Helmet>
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}

            gtag('consent', 'default', {
              'ad_storage': 'denied',
              'ad_user_data': 'denied',
              'ad_personalization': 'denied',
              'analytics_storage': 'denied',
              'region': ['GB', 'BE', 'BG', 'CZ', 'DK', 'CY', 'LV', 'LT', 'LU', 'ES', 'FR', 'HR', 'IT', 'PL', 'PT', 'RO', 'SI', 'HU', 'MT', 'NL', 'AT', 'IS', 'LI', 'NO', 'SK', 'FI', 'SE', 'DE', 'EE', 'IE', 'EL']
            });
            gtag('consent', 'default', {
              'ad_storage': 'granted',
              'ad_user_data': 'granted',
              'ad_personalization': 'granted',
              'analytics_storage': 'granted'
            });
            gtag('js', new Date());
            gtag('config', 'G-ZN74J4K3PE');
          `}
        </script>
        {/* <script async src='https://www.googletagmanager.com/gtag/js?id=G-ZN74J4K3PE'></script> */}
      </Helmet>
      {!hideHeader && !hideTopBanner && (
        <TopBanner
          showTopBanner={showTopBanner}
          locale={locale}
          handleShowTopBanner={handleShowTopBanner}
        />
      )}
      {!hideHeader && (
        <Header
          isMultilingual={isMultilingual}
          currentLocale={locale}
          currentPathname={location.pathname}
          origin={origin}
          showTopBanner={showTopBanner}
          displayLanguages={displayLanguages}
        />
      )}
      <Main $showTopBanner={showTopBanner}>{children}</Main>
      {!isSupportPage && <Footer locale={locale} origin={origin} />}
      <PrivacyPolicy />
      <GlobalStyle />
      <FloatBar />
      {/* ContactBar 在最底部要预留高度 */}
      <ContactBar locale={locale} />
    </>
  )
}
